// source: api/dashboard-admin/v1/task_settings_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.dashboard_admin.TaskSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard_admin.TaskSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard_admin.TaskSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard_admin.TaskSettings.displayName = 'proto.dashboard_admin.TaskSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard_admin.TaskSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard_admin.TaskSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard_admin.TaskSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard_admin.TaskSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoDuration: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blurFaceEnable: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    officeAssessment: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    blurBackgroundEnable: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard_admin.TaskSettings}
 */
proto.dashboard_admin.TaskSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard_admin.TaskSettings;
  return proto.dashboard_admin.TaskSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard_admin.TaskSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard_admin.TaskSettings}
 */
proto.dashboard_admin.TaskSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVideoDuration(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlurFaceEnable(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfficeAssessment(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlurBackgroundEnable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard_admin.TaskSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard_admin.TaskSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard_admin.TaskSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard_admin.TaskSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoDuration();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlurFaceEnable();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOfficeAssessment();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getBlurBackgroundEnable();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 video_duration = 1;
 * @return {number}
 */
proto.dashboard_admin.TaskSettings.prototype.getVideoDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard_admin.TaskSettings} returns this
 */
proto.dashboard_admin.TaskSettings.prototype.setVideoDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool blur_face_enable = 2;
 * @return {boolean}
 */
proto.dashboard_admin.TaskSettings.prototype.getBlurFaceEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.TaskSettings} returns this
 */
proto.dashboard_admin.TaskSettings.prototype.setBlurFaceEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool office_assessment = 3;
 * @return {boolean}
 */
proto.dashboard_admin.TaskSettings.prototype.getOfficeAssessment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.TaskSettings} returns this
 */
proto.dashboard_admin.TaskSettings.prototype.setOfficeAssessment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool blur_background_enable = 4;
 * @return {boolean}
 */
proto.dashboard_admin.TaskSettings.prototype.getBlurBackgroundEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.dashboard_admin.TaskSettings} returns this
 */
proto.dashboard_admin.TaskSettings.prototype.setBlurBackgroundEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.dashboard_admin);
